<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-comments text-primary mr-2"></i>
                    Ficha de Consulta
                </h4>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col xs="12" sm="5">
                <b-card>
                    <b-row slot="header">
                        <b-col xs="12" class="d-flex flex-row justify-content-between align-items-center">
                            <div>Datos de la Consulta</div>
                            <div v-if="$_rolesMixin_checkRoles([roles.queriesChief, roles.queriesStaff])">
                                <router-link :to="{ path: '/queries/edit/'+query.uuid }">
                                    <button class="btn btn-primary btn-sm">
                                        <i class="fa fa-pencil mr-2"></i>Editar Consulta
                                    </button>
                                </router-link>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Consulta Número:</b> {{ query.number }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Fecha:</b> {{ query.date | dateFormat('DD/MM/YYYY') }}
                            <b>Hora:</b> {{ query.date | dateFormat('HH:mm') }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Prioridad:</b>
                            <span class="pl-1">
                                <template v-if="!!query.urgent">Urgente</template>
                                <template v-else>Normal</template>
                            </span>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Estado:</b> {{ queryStatus }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Creada Por:</b> {{ query.createdBy.name }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Asesor:</b> {{ query.adviser.name }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Sede:</b> {{ query.headquarters.name }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Origen de la Consulta:</b> {{ queryOrigin }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Categoría:</b> {{ query.category.name }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Proyectos:</b>&nbsp;<span v-for="project in query.associatedProjects">{{project.name}},&nbsp;</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>

            <b-col xs="12" sm="7">
                <b-card>
                    <b-row slot="header">
                        <b-col xs="12" class="d-flex flex-row justify-content-between align-items-center">
                            <div>Datos de Socio/Interesado</div>

                            <div v-if="isMemberQuery">
                                <router-link
                                    :to="{ path: '/partners/accounts/edit/'+client.uuid }"
                                    target="_blank">
                                    <button class="btn btn-primary btn-sm">
                                        <i class="fa fa-link mr-2"></i>Ver Ficha
                                    </button>
                                </router-link>
                            </div>
                            <div v-else>
                              <button class="btn btn-primary btn-sm" @click="updateClientModal(client)">
                                <i class="fa fa-pencil mr-2"></i>Ver Ficha
                              </button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Interesado:</b>
                            <span class="ml-1">
                                <template v-if="isMemberQuery">Socio</template>
                                <template v-else-if="query.potentialMember">Posible Socio</template>
                                <template v-else>No Socio</template>
                            </span>
                        </b-col>
                    </b-row>

                    <b-row v-if="isMemberQuery">
                        <b-col xs="12">
                            <b>Código:</b> {{ client.code }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Nombre:</b> {{ client.name }}
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b>Apellidos:</b> {{ client.surname }}
                        </b-col>
                    </b-row>

                    <b-row v-if="!!client.phones || !!client.phone">
                        <b-col xs="12">
                            <template v-if="!!client.phones">
                                <b>Telefonos:</b>
                                <span
                                    v-for="phone in client.phones"
                                    :key="phone.uuid"
                                    class="pl-1">
                                    {{ phone.phone }}
                                </span>
                            </template>
                            <template v-else-if="!!client.phone">
                                <b>Telefono:</b>
                                <span class="pl-1">
                                    {{ client.phone }}
                                </span>
                            </template>
                        </b-col>
                    </b-row>

                    <b-row v-if="!!client.emails || !!client.email">
                        <b-col xs="12">
                            <template v-if="!!client.emails">
                                <b>Emails:</b>
                                <span
                                    v-for="email in client.emails"
                                    :key="email.uuid"
                                    class="pl-1">
                                    {{ email.email }}
                                </span>
                            </template>
                            <template v-else-if="!!client.email">
                                <b>Email:</b>
                                <span class="pl-1">
                                    {{ client.email }}
                                </span>
                            </template>
                        </b-col>
                    </b-row>

                    <b-row v-if="!!client.headquarters">
                        <b-col xs="12">
                            <b>Sede:</b> {{ client.headquarters.name }}
                        </b-col>
                    </b-row>

                    <template v-if="!!client.addresses && client.addresses.length > 0">
                        <b-row>
                            <b-col xs="12">
                                <b>Provincia:</b> {{ client.addresses[0].province }}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col xs="12">
                                <b>Población:</b> {{ client.addresses[0].town }}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col xs="12">
                                <b>CP:</b> {{ client.addresses[0].postalCode }}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col xs="12">
                                <b>Dirección:</b> {{ client.addresses[0].address }}
                            </b-col>
                        </b-row>
                    </template>

                    <b-row v-if="isMemberQuery">
                        <b-col xs="12">
                            <b>Estado:</b>
                            <span class="px-1">
                                <template v-if="!!client.active">Activo</template>
                                <template v-else>No Activo</template>
                            </span>
                            <b>Situación:</b>
                            <span class="pl-1">
                                <template v-if="!!client.located">Localizado</template>
                                <template v-else>No Localizado</template>
                            </span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12" sm="5">
                <b-card>
                    <b-row slot="header">
                        <b-col xs="12">
                            Comentarios
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <template v-if="!!query.comment">{{ query.comment }}</template>
                            <template v-else>
                                <div class="text-secondary">Sin comentarios</div>
                            </template>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>

            <b-col xs="12" sm="7">
                <b-card>
                    <b-row slot="header">
                        <b-col xs="12">
                            Descripción
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            {{ query.description }}
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">

                <query-issues v-model="queryIssues" :queryId="query.uuid" :hideAddIssueButton="isClosed"></query-issues>

            </b-col>
        </b-row>

        <b-row class="mb-2">
            <b-col xs="12">
                <b-card class="m-0">
                    <b-row slot="header">
                        <b-col xs="12" class="d-flex flex-row justify-content-between align-items-center">
                            <div>Respuesta</div>
                            <div>
                                <button
                                    @click="() => this.$refs.answerTypesModal.show()"
                                    v-if="$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff]) && !isClosed"
                                    class="btn btn-primary btn-sm">
                                    <i class="fa fa-upload mr-2"></i>Cargar Respuesta Tipo
                                </button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col xs="12">
                            <b-form-textarea
                                id="asnwer"
                                v-model="query.answer"
                                placeholder="Respuesta a la consulta"
                                :disabled="isClosed"
                                :rows="3"
                                :max-rows="6">
                            </b-form-textarea>
                            <b-form-checkbox
                                class="mt-2"
                                type="checkbox"
                                v-if="!isClosed"
                                v-model="query.saveAnswerType">Guardar como Respuesta Tipo
                            </b-form-checkbox>
                        </b-col>

                        <b-modal
                            ref="answerTypesModal"
                            hide-footer
                            size="lg"
                            title="Selecciona una respuesta tipo"
                            centered>
                            <template v-if="!!queryAnswerTypes && queryAnswerTypes.length > 0">
                                <b-list-group class="m-2">
                                    <b-list-group-item
                                        v-for="answerType in queryAnswerTypes"
                                        :key="answerType.uuid"
                                        href="#"
                                        class="d-flex justify-content-between align-items-center"
                                        @click="loadAnswerType(answerType)">
                                        <div>
                                            <div>{{ answerType.query }}</div>
                                            <small>{{ answerType.answer }}</small>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                            </template>
                            <template v-else>
                                <p class="my-3 text-center">
                                    No hay niguna respuesta tipo para la categoría de la consulta
                                </p>
                            </template>
                        </b-modal>

                    </b-row>

                </b-card>
            </b-col>
        </b-row>

        <b-row class="flex-row-reverse" v-if="!isMemberQuery && !isClosed">
            <div>
                <b-form-checkbox
                    type="checkbox"
                    :disabled="!query.canModifyPotentialMember"
                    v-model="query.potentialMember">Enviar a Captación Comercial
                </b-form-checkbox>
            </div>
        </b-row>

        <b-row class="mb-3 mt-3" v-if="!isClosed">
            <b-col xs="12" class="d-flex flex-row justify-content-between align-items-end">
                <button
                    @click="saveAnswer"
                    v-if="$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff])"
                    class="btn btn-secondary btn-md">
                    <i class="fa fa-save mr-2"></i>Guardar
                </button>

                <button
                    @click="showReScheduleModal"
                    v-if="$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff])"
                    class="btn btn-secondary btn-md">
                    <i class="fa fa-calendar mr-2"></i>Reagendar
                </button>

                <button
                    @click="closeUnresolve"
                    v-if="$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff])"
                    class="btn btn-danger btn-md">
                    <i class="fa fa-times mr-2"></i>Cerrar sin Resolver
                </button>

                <div class="d-flex flex-column align-items-end">
                    <div>
                        <button
                            @click="resolve"
                            v-if="$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff])"
                            class="btn btn-primary btn-md">
                            <i class="fa fa-check mr-2"></i>Resolver Consulta
                        </button>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-modal
            ref="reScheduleModal"
            hide-footer
            size="md"
            title="Reagendar la consulta"
            centered>

            <template>

                <b-row class="px-3">

                    <b-form-group
                        label="<strong>Fecha de notificacion *</strong>"
                        :label-cols="5"
                        :horizontal="true"
                        class="w-100 mb-3">
                        <date-picker
                            :min-date="getTomorrowDate()"
                            v-model="reschedule.date"
                            class="p-0 form-control date-picker-w-100 date-picker-custom-border">
                        </date-picker>
                    </b-form-group>

                    <b-form-group class="w-100 mb-3">

                        <b-form-textarea
                            v-model="reschedule.message"
                            placeholder="Mensaje personalizado *"
                            :rows="3"
                            :max-rows="6">
                        </b-form-textarea>

                    </b-form-group>

                </b-row>

                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button
                        @click="rescheduleQuery"
                        class="btn btn-brand btn-primary col-auto btn-lg float-right"
                        :disabled="!reschedule.date"
                        sm="12">
                        Reagendar
                    </button>
                </b-row>

            </template>

        </b-modal>
        <b-modal
          id="updateClientModal"
          ref="updateClientModal"
          title="Editar No Socio"
          hide-footer
          centered
        >
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>NIF</strong>"
              label-for="nif"
              :horizontal="false"
              class="w-100 mb-0"
            >
              <b-form-input
                id="nif"
                name="nif"
                type="text"
                placeholder="NIF"
                v-model="selectedClient.row.nif"
                class="w-100"
                v-validate="'required|min:9'"
                :state="validateState('nif')"
                aria-describedby="check_nif"
              >
              </b-form-input>
              <div class="text-danger text-right" id="check_nif">
                <small>{{ errors.first("nif") }}</small>
              </div>
            </b-form-group>
          </b-row>
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>Nombre</strong>"
              label-for="name"
              :horizontal="false"
              class="w-100 mb-0"
            >
              <b-form-input
                id="name"
                name="name"
                type="text"
                placeholder="Nombre"
                v-model="selectedClient.row.name"
                class="w-100"
                v-validate="'required|min:3'"
                :state="validateState('name')"
                aria-describedby="check_name"
              >
              </b-form-input>
              <div class="text-danger text-right" id="check_name">
                <small>{{ errors.first("name") }}</small>
              </div>
            </b-form-group>
          </b-row>
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>Apellidos</strong>"
              label-for="surname"
              :horizontal="false"
              class="w-100 mb-0"
            >
              <b-form-input
                id="surname"
                name="surname"
                type="text"
                placeholder="Apellido"
                v-model="selectedClient.row.surname"
                class="w-100"
                v-validate="'required|min:3'"
                :state="validateState('surname')"
                aria-describedby="check_surname"
              >
              </b-form-input>
              <div class="text-danger text-right" id="check_surname">
                <small>{{ errors.first("surname") }}</small>
              </div>
            </b-form-group>
          </b-row>
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>Sexo *</strong>"
              label-for="sex"
              label-cols="4"
              :horizontal="false"
              class="w-100 mb-0">
              <multiselect
                name="sex"
                v-model="selectedClient.row.sex"
                :options="sex.map(type => type.uuid)"
                :custom-label="opt => sex.find(x => x.uuid == opt).name"
                :multiple="false"
                :allowEmpty="false"
                placeholder="Seleccione"
                selectLabel="+"
                deselectLabel="-"
                v-if="sex">
              </multiselect>
            </b-form-group>
          </b-row>
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>F. de Nacimiento</strong>"
              label-for="partnerBirthdate"
              label-cols="4"
              :horizontal="false"
              class="w-100  mb-0">
              <v-date-picker v-model="entityBirthdayFormatted" :max-date="new Date()" popoverDirection="top">
                <template v-slot="{ inputValue, inputEvents }">
                  <b-form-input
                    :value="inputValue"
                    v-on="inputEvents"
                    @change="changeBirthday"
                    id="partnerBirthdate"
                    name="partnerBirthdate"
                    class="w-100"
                    v-validate="'partnerBirthdate'"
                    :state="validateState('partnerBirthdate')"
                    aria-describedby="check_partnerBirthdate" />
                </template>
              </v-date-picker>
            </b-form-group>
            <div class="text-danger text-right" id="check_partnerBirthdate">
              <small>{{ errors.first('partnerBirthdate') }}</small>
            </div>
          </b-row>
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>Teléfonos</strong>"
              label-for="phone"
              :horizontal="false"
              class="w-100 mb-0"
            >
              <b-form-input
                id="phone"
                name="phone"
                type="text"
                placeholder="Teléfono"
                class="w-100"
                @keypress.enter.native="addPhone($event.target.value)"
                :state="validateState('phone')"
                aria-describedby="check_phone"
                v-model="phone"
                autocomplete="nope"
              >
              </b-form-input>
              <div class="text-danger text-right" id="check_phone">
                <small>{{ errors.first("phone") }}</small>
              </div>
              <b-list-group>
                <b-list-group-item
                  v-for="(phone,index) in selectedClient.row.phones"
                  :key="index">{{ phone.phone }}
                  <div @click="removePhone(phone.phone)">
                    <template>
                      <b-badge
                        variant="danger"
                        class="float-left"
                        pill>Borrar
                      </b-badge>
                    </template>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-form-group>
          </b-row>
          <b-row class="mt-2 mx-5">
            <b-form-group
              label="<strong>Emails</strong>"
              label-for="email"
              :horizontal="false"
              class="w-100 mb-0"
            >
              <b-form-input
                id="email"
                name="email"
                type="text"
                placeholder="Email"
                class="w-100"
                @keypress.enter.native="addEmail($event.target.value)"
                v-validate="'email'"
                :state="validateState('email')"
                aria-describedby="check_email"
                v-model="email"
                autocomplete="nope"
              >
              </b-form-input>
              <div class="text-danger text-right" id="check_email">
                <small>{{ errors.first("email") }}</small>
              </div>
              <b-list-group>
                <b-list-group-item
                  v-for="(email, index) in selectedClient.row.emails"
                  :key="index">{{ email.email }}
                  <template v-if="email.main">
                    <b-badge
                      variant="primary"
                      class="float-right"
                      pill>Principal
                    </b-badge>
                  </template>
                  <template v-else>
                    <b-badge
                      variant="secondary"
                      class="float-right"
                      pill>Secundario
                    </b-badge>
                  </template>

                  <div @click="changeEmailStatus(email.email)">
                    <template v-if="email.status == 'ACTIVE'">
                      <b-badge
                        variant="success"
                        class="float-right"
                        pill>ACTIVO
                      </b-badge>
                    </template>
                    <template v-else-if="email.status == 'UNWANTED'">
                      <b-badge
                        variant="warning"
                        class="float-right"
                        pill>NO DESEA
                      </b-badge>
                    </template>
                    <template v-else>
                      <b-badge
                        variant="danger"
                        class="float-right"
                        pill>ERRONEO
                      </b-badge>
                    </template>
                  </div>
                  <div @click="removeEmail(email.email)">
                    <template>
                      <b-badge
                        variant="danger"
                        class="float-left"
                        pill>Borrar
                      </b-badge>
                    </template>
                  </div>

                </b-list-group-item>
              </b-list-group>
            </b-form-group>
          </b-row>
          <b-row class="mt-2 mx-5">
            <location-form
              v-if="modal"
              :community-required="false"
              :province-required="true"
              :initial-community="selectedClient.row.address.community"
              :initial-province="selectedClient.row.address.province"
              :initial-town="selectedClient.row.address.town"
              :initial-postal-code="(selectedClient.row.address.postalCode != undefined && selectedClient.row.address.postalCode != null) ? parseInt(selectedClient.row.address.postalCode) : 0"
              :initial-address="selectedClient.row.address.address"
              @community-change="community => {selectedClient.row.address.community = community}"
              @province-change="province => {selectedClient.row.address.province = province}"
              @town-change="town => {selectedClient.row.address.town = town}"
              @postal-code-change="postalCode => {selectedClient.row.address.postalCode = postalCode}"
              @address-change="address => {selectedClient.row.address.address = address}"></location-form>
          </b-row>
          <b-row
            class="
                  border-top
                  pt-3
                  px-3
                  flex-row-reverse
                  align-content-between
                  mt-4
                "
          >
            <button
              class="btn btn-brand btn-primary btn-lg float-right"
              @click="updateClient"
            >
              Guardar
            </button>
          </b-row>
        </b-modal>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import form from "@/helpers/form";
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import {getQuery, saveAnswerQuery, reScheduleQuery} from '@/api/query-api';
    import {getMember} from '@/api/member-api';
    import {getClient} from '@/api/client-api';
    import {getQueryAnswerTypes} from '@/api/query-answer-type-api';
    import {roles} from '@/constants/roles-constants';
    import {getQueryOriginByCode, getQueryStatusByCode} from '@/helpers/query-helper';
    import QueryIssues from './Component/QueryIssues';
    import LocationForm from '@/components/location/LocationForm';
    import { request } from "@/helpers/services";
    import moment from "moment";

    setupCalendar({
        firstDayOfWeek: 2, // Monday
    });

    export default {
        name: "query-overview",
        components: {
            Multiselect,
            DatePicker,
            QueryIssues,
            LocationForm
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/queries/list',
                        brand: 'fa fa-arrow-left'
                    }
                ],
                entity: {
                  string: null,
                  page: 1,
                  itemsPerPage: 10,
                },
                query: {
                    uuid: null,
                    client: null,
                    answer: null,
                    saveAnswerType: null
                },
                reschedule: {
                    date: null,
                    message: null
                },
                client: {
                    uuid: null
                },
                sendClientToCommercial: false,
                roles,
                queryAnswerTypes: [],
                queryIssues: [],
                modal: false,
                sex: [
                  {uuid: 1, name: 'Hombre'},
                  {uuid: 2, name: 'Mujer'},
                  {uuid: 3, name: 'Otra identidad'},
                ],
                selectedClient: {
                  row: {
                    uuid: null,
                    name: null,
                    surname: null,
                    sex: null,
                    birthday: null,
                    nif: null,
                    phones: [],
                    emails: [],
                    address: {
                      name: null,
                      address: null,
                      town: null,
                      postalCode: null,
                      province: null,
                      community: null,
                      main: true
                    },
                    headquartersId: null
                  }
                },
              email: '',
              phone: '',
            }
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQuery(this.$route.params.uuid);
        },
        computed: {
            satisfiedDependencies() {
                return (
                    !!this.query.uuid
                    && !!this.client.uuid
                );
            },
            queryStatus() {
                return !!this.query.status
                    ? getQueryStatusByCode(this.query.status)
                    : null;
            },
            queryOrigin() {
                return !!this.query.origin
                    ? getQueryOriginByCode(this.query.origin)
                    : null;
            },
            isMemberQuery() {
                return (
                    !!this.query.client
                    && !!this.query.client.uuid
                    && !!this.query.client.class
                    && this.query.client.class === 'Member'
                );
            },
          entityBirthdayFormatted: {
            get() {
              if(!this.selectedClient.row.birthday) return null;
              return new Date(this.selectedClient.row.birthday);
            },
            set(newValue) {
              if(!newValue || newValue === "") {
                this.selectedClient.row.birthday = null;
                return;
              }
              this.selectedClient.row.birthday = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }
          },
            isClosed() {
                return this.query.status === "CLOSED" || this.query.status === "RESOLVED"
            }
        },
        methods: {
            async requests(path, method, okCode, entity, data = null) {
              this.$_loadingMixin_showLoading();
              this[entity] = await request(path, method, okCode, data);
              this.$_loadingMixin_hideLoading();

              return this[entity];
            },
            loadClientData() {
                if (this.isMemberQuery) {
                    this.getMember(this.query.client.uuid);
                } else {
                    this.getClient(this.query.client.uuid);
                }
            },

            async getQuery(queryId) {
                this.$_loadingMixin_showLoading();
                await getQuery(queryId)
                    .then((query) => {
                        this.query = query;
                        this.loadClientData();
                        this.getQueryAnswerTypes();
                    });
                this.$_loadingMixin_hideLoading();
            },

            async getClient(clientId) {
                this.$_loadingMixin_showLoading();
                await getClient(clientId)
                    .then((client) => {
                        this.client = client;
                        this.client.addresses = [];

                        if (client.address) {
                            this.client.addresses[0] = client.address;
                        }
                    });
                this.$_loadingMixin_hideLoading();
            },

            async getMember(memberId) {
                this.$_loadingMixin_showLoading();
                await getMember(memberId)
                    .then((member) => {
                        this.client = member;
                    });
                this.$_loadingMixin_hideLoading();
            },

            async getQueryAnswerTypes() {
                this.$_loadingMixin_showLoading();
                await getQueryAnswerTypes()
                    .then((queryAnswerTypes) => {
                        this.queryAnswerTypes = queryAnswerTypes.filter(
                            queryAnswerType => queryAnswerType.active && queryAnswerType.categories.find(
                                category => category.uuid === this.query.category.uuid));
                    });
                this.$_loadingMixin_hideLoading();
            },

            loadAnswerType(answerType) {
                this.query.answer = answerType.answer;
                this.query.saveAnswerType = false;
                this.$refs.answerTypesModal.hide();
            },

            async save(status, success) {
                this.$_loadingMixin_showLoading();
                await saveAnswerQuery(this.query.uuid, status, this.query.answer, this.query.saveAnswerType, this.query.potentialMember)
                    .then(() => {
                        success();
                    })
                    .catch(() => this.$_notificationMixin_error("Operación no realizada", "Se ha producido un error al guardar los datos"));
                this.$_loadingMixin_hideLoading();
            },

            saveAnswer() {
                this.save("OPEN", () => {
                    this.$_notificationMixin_success("Consulta guardada", "Se han guardado los datos correctamente");
                    this.backToQueryList();
                });
            },

            closeUnresolve() {
                if (this.queryIssues.length === 0) {
                    this.$_notificationMixin_warn("Operación no válida", "Tiene que añadir al menos una incidencia antes de cerrar la consulta sin resolver");
                    return;
                }

                swal({
                    title: '¿Estás seguro de cerrar la consulta sin resolver?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, cerrar!'
                }).then((result) => {
                    if (result.value) {
                        this.save("CLOSED", () => {
                            this.query.status = "CLOSED";
                            this.$_notificationMixin_success("Consulta cerrada sin resolver", "La consulta se ha cerrado correctamente");
                            this.backToQueryList();
                        });
                    }
                });
            },

            resolve() {
                if (this.query.answer == null || this.query.answer.trim() === '') {
                    this.$_notificationMixin_warn("Operación no válida", "Tiene que añadir una respuesta antes de cerrar la consulta como resuelta");
                    return;
                }

                swal({
                    title: '¿Estás seguro de cerrar la consulta como resuelta?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, resolver!'
                }).then((result) => {
                    if (result.value) {
                        this.save("RESOLVED", () => {
                            this.query.status = "RESOLVED";
                            this.$_notificationMixin_success("Consulta resuelta", "La consulta se ha resuelto correctamente");
                            this.backToQueryList();
                        });
                    }
                });
            },

            showReScheduleModal() {
                this.reschedule.date = null;
                this.reschedule.message = null;
                this.$refs.reScheduleModal.show();
            },

            async rescheduleQuery() {
                this.$refs.reScheduleModal.hide();
                this.$_loadingMixin_showLoading();
                await reScheduleQuery(this.query.uuid, this.reschedule.date, this.reschedule.message)
                    .then(() => this.$_notificationMixin_success("Consulta reagendada", "La consulta se ha reagendado correctamente."))
                    .catch(() => this.$_notificationMixin_error("Error al reagendar", "Se ha producido un error al regendar la consulta."));
                this.$_loadingMixin_hideLoading();
            },

            backToQueryList() {
                this.$router.push({path: '/queries/list'});
            },

            getTomorrowDate() {
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                return tomorrow;
            },

            async updateClientModal(item) {
              this.modal = false;

              this.client = item;

              this.selectedClient.row.uuid = null;
              this.selectedClient.row.nif = null;
              this.selectedClient.row.name = null;
              this.selectedClient.row.surname = null;
              this.selectedClient.row.sex = null;
              this.selectedClient.row.birthday = null;
              this.selectedClient.row.phones = [];
              this.selectedClient.row.emails = [];
              this.selectedClient.row.phone = null;
              this.selectedClient.row.email = null;
              this.selectedClient.row.address.name = null;
              this.selectedClient.row.address.community = null;
              this.selectedClient.row.address.province = null;
              this.selectedClient.row.address.town = null;
              this.selectedClient.row.address.postalCode = null;
              this.selectedClient.row.address.address = null;
              this.selectedClient.row.address.main = true;

              if (this.client.uuid) {
                this.selectedClient.row.uuid = this.client.uuid;
              }
              if (this.client.nif) {
                this.selectedClient.row.nif = this.client.nif;
              }
              if (this.client.name) {
                this.selectedClient.row.name = this.client.name;
              }
              if (this.client.surname) {
                this.selectedClient.row.surname = this.client.surname;
              }
              if (this.client.sex) {
                this.selectedClient.row.sex = this.client.sex;
              }
              if (this.client.birthday) {
                this.selectedClient.row.birthday = this.client.birthday;
              }
              if (this.client.phones) {
                this.selectedClient.row.phones = this.client.phones;
              }
              if (this.client.emails) {
                this.selectedClient.row.emails = this.client.emails;
              }
              if (this.client.address) {
                // this.provinces = await this.readProvinces();
                //
                // for (var i = 0; i < this.provinces.length; i++) {
                //   if (this.client.address.province == this.provinces[i].name) {
                //     this.client.address.community = this.provinces[i].community.name;
                //   }
                // }

                this.selectedClient.row.address = this.client.address;
              }

              this.modal = true;
              this.$refs.updateClientModal.show();
            },

            async updateClient() {
              try {
                if (
                  !this.selectedClient.row.address.province
                  ||
                  !this.selectedClient.row.address.town
                  ||
                  !this.selectedClient.row.address.postalCode
                  ||
                  !this.selectedClient.row.address.main
                ) {
                  this.selectedClient.row.address = null;
                }

                if (this.validateState('phone')) {
                  this.addPhone(this.phone);
                }

                if (this.validateState('email')) {
                  this.addEmail(this.email);
                }

                await this.requests(
                  `clients/${this.selectedClient.row.uuid}`,
                  "post",
                  200,
                  "clients",
                  this.selectedClient.row
                );

                this.selectedClient.row.address = {
                  name: null,
                  address: null,
                  town: null,
                  postalCode: null,
                  province: null,
                  community: null,
                  main: true
                };

                this.$_notificationMixin_success('Operación completada', 'El no socio ha sido actualizado');
                this.$refs.updateClientModal.hide();
                this.getClient(this.selectedClient.row.uuid);
              } catch (error) {
                this.$_loadingMixin_hideLoading();

                this.$_notificationMixin_error(
                  "Operación no completada",
                  "Ocurrio un error al actualizar el no socio"
                );
                this.$refs.updateClientModal.hide();
              }
            },

            validateState(ref) {
              if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
              ) {
                return !this.errors.has(ref);
              } else {
                return null;
              }
            },

          changeBirthday(value) {
            this.entityBirthdayFormatted = value;
          },
          addPhone(number) {
            if (form.phone(number)) {
              this.selectedClient.row.phones.push({phone: number})
              this.phone = ""
            }
          },
          addEmail(emailVal) {
            let email2 = {
              email: '',
              status: '',
              main: false
            };

            if (form.email(emailVal)) {
              if (this.selectedClient.row.emails.length == 0) {
                email2.email = emailVal;
                email2.main = true;
                email2.status = 'ACTIVE';
              } else {
                email2.email = emailVal;
                email2.main = false;
                email2.status = 'ACTIVE';
              }
              this.selectedClient.row.emails.push(email2);
              this.email = null;
            }
          },
          changeEmailStatus(email) {
            this.selectedClient.row.emails.find(e => {
              if (e.email == email) {
                switch (e.status) {
                  case 'ACTIVE':
                    e.status = 'UNWANTED';
                    break;
                  case 'UNWANTED':
                    e.status = 'WRONG';
                    break;
                  default:
                    e.status = 'ACTIVE';
                }
                return e
              }
            });
          },
          removeEmail(email) {
            this.selectedClient.row.emails = this.selectedClient.row.emails.filter(function (e) {
              return e.email !== email;
            })
          },
          removePhone(phone) {
            this.selectedClient.row.phones = this.selectedClient.row.phones.filter(function (e) {
              return e.phone !== phone;
            })
          },
        },
    }
</script>
